import Layout from '@modules/layout/components/layout.vue';
import Permissions from '@security/permissions';

const ProgramListPage = () =>
    import ('@modules/program/components/program-list-page.vue');
const ProgramFormPage = () =>
    import ('@modules/program/components/program-form-page.vue');
const ProgramViewPage = () =>
    import ('@modules/program/components/program-view-page.vue');
const ProgramImporterPage = () =>
    import ('@modules/program/components/program-importer-page.vue');
//const SubprogramFormModal = () => import ('@modules/subprogram/components/subprogram-form-modal.vue');

//const SubprogramListTable = () => import ('@modules/subprogram/components/subprogram-list-table.vue');
const SubprogramFormPage = () =>
  import('@modules/subprogram/components/subprogram-form-page.vue');

export default [{
    name: '',
    path: '',
    component: Layout,
    meta: { auth: true },
    children: [{
        props: true,
        name: 'programList',
        path: '/program/:type?',
        component: ProgramListPage,
        exact: true,
            meta: {
                auth: true,
                permission: Permissions.values.programView,
            },
        },
        {
            props: true,
            name: 'programNew',
            path: '/program/new/:type?',
            component: ProgramFormPage,
            meta: {
                auth: true,
                permission: Permissions.values.programCreate,
            },
        },
        {
            name: 'programImporter',
            path: '/program/import',
            component: ProgramImporterPage,
            meta: {
                auth: true,
                permission: Permissions.values.programImport,
            },
        },
        {
            props: true,
            name: 'programEdit',
            path: '/program/:id/edit/:type',
            component: ProgramFormPage,
            meta: {
                auth: true,
                permission: Permissions.values.programEdit,
            },
        },
        {
            name: 'programView',
            path: '/program/:id',
            component: ProgramViewPage,
            meta: {
                auth: true,
                permission: Permissions.values.programView,
            },
            props: true,
        },
        {
            name: 'programSubprogramNew',
            path: 'program/subprogram/new/:propertyId/:subpropertyId/:programId/:programType',
            component: SubprogramFormPage,
            meta: {
                auth: true,
                permission: Permissions.values.subprogramCreate,
            },
            props: true,
        },
        {
            name: 'programSubprogramEdit',
            path: 'program/subprogram/:id/edit/:propertyId/:subpropertyId/:programId/:programType',
            component: SubprogramFormPage,
            meta: {
                auth: true,
                permission: Permissions.values.subprogramEdit,
            },
            props: true,
        },
    ],
},];